import { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Zap } from 'lucide-react';
import api from '../services/api';

export default function ResetPassword() {
  const [form, setForm]       = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(false);
  const { token } = useParams();
  const navigate  = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await api.put(`/auth/reset-password/${token}`, { password: form.password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Reset failed. Link may have expired.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><Zap size={22} fill="currentColor" style={{ display:'inline', marginRight:6 }}/>Wispy</div>
        <h1 className="auth-title">Set new password</h1>
        {done ? (
          <p style={{ color: '#4ecf88', marginTop: 8 }}>✅ Password reset successfully! Redirecting to login…</p>
        ) : (
          <form onSubmit={handle} style={{ display:'flex', flexDirection:'column', gap:16, marginTop:20 }}>
            {[['password','New password'],['confirm','Confirm password']].map(([k,l]) => (
              <div className="form-group" key={k}>
                <label className="form-label">{l}</label>
                <input className="input" type="password" placeholder="Min 8 characters" value={form[k]}
                  onChange={e => setForm(f=>({...f,[k]:e.target.value}))} required minLength={8}/>
              </div>
            ))}
            <button className="btn btn-primary btn-lg" type="submit" disabled={loading} style={{width:'100%'}}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
            <Link to="/login" style={{textAlign:'center',fontSize:13,color:'var(--text3)',textDecoration:'none'}}>← Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
